export default __webpack_public_path__ + "static/media/background.b8d469cc.jpg";